var coll = document.getElementsByClassName("section-overview__collapsible");


for (let i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
        // Close all other collapsible contents
        for (let j = 0; j < coll.length; j++) {
            if (j !== i) {
                coll[j].classList.remove("active");
                coll[j].nextElementSibling.classList.add("hidden");
            }
        }
        // Toggle the clicked collapsible
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("hidden")
    });
}
